import styled, { css } from 'styled-components'
import {
    desktopBreakpoint,
    tabletBreakpoint,
    mobileBreakpoint,
    GhostButton,
    wideScreenBreakpoint,
} from 'react-components'
import ExternalLink from '../../../common/external-link'
import { LIST_VIEW_CONFIG } from '../../../../constants/search-result-listing'

export const Container = styled.div`
    width: 100%;
    padding: 0;
    min-height: 80vh;
`

export const ListingsContainer = styled.div<{ isGridView: boolean }>`
    display: flex;
    flex-direction: column;
    gap: 0;
    margin-top: 1.5rem;

    @media only screen and (max-width: ${mobileBreakpoint.max}px) {
        > * {
            margin-bottom: 1rem;

            &:last-child {
                border-bottom: none;
                margin-bottom: 0;
                padding-bottom: 0;
            }
        }
    }

    ${({ isGridView }) =>
        !isGridView &&
        `
        @media only screen and (min-width: ${tabletBreakpoint.min}px) {
            > * {
                /* List view styles if needed */
            }
        }
    `}
`

export const ObserverTarget = styled.div`
    width: 100%;
`

export const VirtualizedItemWrapper = styled.div`
    padding-bottom: 1.5rem;
`

export const ListItemWrapper = styled.div``

export const SectionHeading = styled.h2`
    font-size: 1.5rem;
    font-weight: 600;
    margin: 2rem 0 1rem;
    color: ${({ theme }) => theme.colors?.tfwBlack87 || '#000'};

    &:first-of-type {
        margin-top: 1.5rem;
    }

    @media (max-width: ${mobileBreakpoint.max}px) {
        font-size: 1.25rem;
        margin: 1.5rem 0 1rem;
    }
`

export const FooterWrapper = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: stretch;
    width: 100%;
    grid-column: 1 / -1;
`

export const LoadMoreButton = styled(GhostButton)(
    ({ theme }) => css`
        padding: 0.5rem 1.25rem;
        width: 40%;
        height: 3rem;
        text-align: center;
        justify-content: center;

        transition: all 0.3s ease;

        &&& {
            color: ${theme.colors.tfwBlack87};
            border-color: ${theme.colors.tfwBlack87};
        }

        @media only screen and (min-width: ${tabletBreakpoint.min}px) {
            padding: 0.75rem 1.25rem;
        }

        @media only screen and (min-width: ${desktopBreakpoint.min}px) {
            padding: 0.75rem 3.563rem;
        }

        &&&:hover {
            transform: scale(1.05);
            color: ${theme.colors.tfwBlack87};
            background-color: ${theme.colors.tfwYellowHover};
            border-color: ${theme.colors.tfwYellowHover};
            box-shadow: 0 4px 15px rgba(0, 0, 0, 0.2);
        }
    `,
)

export const GridRowWrapper = styled.div`
    display: grid;
    grid-template-columns: repeat(1, minmax(0, 1fr));
    gap: 1.5rem;
    margin-bottom: 1.5rem;

    @media only screen and (min-width: ${tabletBreakpoint.min}px) {
        grid-template-columns: repeat(${LIST_VIEW_CONFIG.TABLET_GRID_ITEMS_PER_ROW}, minmax(0, 1fr));
        gap: 1rem;
    }
    @media only screen and (min-width: ${wideScreenBreakpoint.min}px) {
        grid-template-columns: repeat(${LIST_VIEW_CONFIG.GRID_ITEMS_PER_ROW}, minmax(0, 1fr));
    }
`

export const SectionSpacer = styled.div`
    height: 1.5rem;
    margin-top: 1.5rem;
`

export const Card = styled.div`
    padding: 1.5rem;
    color: ${({ theme }) => theme.colors.tfwBlack87};
    width: 100%;
    text-align: left;
    background-color: #fff;
    border: 1px solid #e6e6e6;
    border-radius: 4px;
    margin-bottom: 2rem;
`

export const Heading = styled.h2(
    ({ theme }) => css`
        font-family: ${theme.typography.font.family.lato};
        font-size: ${theme.typography.font.size.large};
        font-weight: 600;
        line-height: 1.75rem;
        margin-bottom: ${theme.spacing.xSmall};
        color: #282828;
    `,
)

export const Text = styled.p(
    ({ theme }) => css`
        font-family: ${theme.typography.font.family.lato};
        font-size: ${theme.typography.font.size.small};
        line-height: ${theme.typography.font.size.medium};
        margin-bottom: ${theme.spacing.large};
        color: #6f6f6f;

        @media only screen and (min-width: ${tabletBreakpoint.min}px) {
            margin-bottom: 1.75rem;
        }
    `,
)

export const TipsText = styled.p(
    ({ theme }) => css`
        font-family: ${theme.typography.font.family.lato};
        font-size: ${theme.typography.font.size.small};
        line-height: ${theme.typography.font.size.medium};
        margin-bottom: ${theme.spacing.medium};
        font-weight: 600;
        color: #282828;
    `,
)

export const TipsList = styled.ul(
    ({ theme }) => css`
        list-style-type: disc;
        padding-left: ${theme.spacing.large};
        margin-bottom: 0;
        margin-top: ${theme.spacing.xSmall};
    `,
)

export const TipItem = styled.li(
    ({ theme }) => css`
        font-family: ${theme.typography.font.family.lato};
        font-size: ${theme.typography.font.size.small};
        line-height: ${theme.typography.font.size.medium};
        margin-bottom: ${theme.spacing.xSmall};
        padding-left: ${theme.spacing.xxSmall};
        color: #5f5f5f;
    `,
)

export const TipLink = styled(ExternalLink)`
    color: inherit;
    text-decoration: underline;
    cursor: pointer;

    &:hover {
        text-decoration: none;
    }
`
